import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Link } from '../Link';
import { Menu } from '../Menu';
import { NotificationsLink } from '../NotificationsLink';
import { classNames } from '../../utilities';

import { AdminMenuItem } from './AdminMenuItem';
import styles from './AdminMenu.css';
import { adminMenuChildPropTypes } from './admin-menu-prop-types';

export class AdminMenu extends Component {
  constructor() {
    super();

    this.handleAdminMenuButtonClick = this.handleAdminMenuButtonClick.bind(this);

    this.state = {
      disabledButtons: []
    };
  }

  handleAdminMenuButtonClick(index) {
    this.setState(({ disabledButtons }) => ({
      disabledButtons: [...disabledButtons, `menuButton-${index}`]
    }));
  }

  render() {
    const { config } = this.props;
    const { disabledButtons } = this.state;

    return (
      <nav className={styles.adminMenu}>
        <Menu config={config} extraStyles={styles.menu} />

        <ul className={styles.adminMenuList}>
          <div className={styles.adminMenuListLeft}>
            <li className={styles.adminMenuLogo}>
              <a
                className={classNames(styles.adminMenuLogoLink, 'hide-text-relative')}
                href={config.logoUrl}>
                Website Homepage
              </a>
            </li>

            {config.menuButtons &&
              config.menuButtons.map((button, index) => (
                <Link
                  buttonLinkStyle="primary"
                  disabled={disabledButtons.indexOf(`menuButton-${index}`) !== -1}
                  extraStyles={styles.adminMenuButton}
                  handleClick={() => this.handleAdminMenuButtonClick(index)}
                  key={button.text}
                  type="button"
                  url={button.url}>
                  {button.text}
                </Link>
              ))}
          </div>

          <div className={styles.adminMenuListRight}>
            {config.maintenance && (
              <span className={styles.adminMenuMaintenance}>Maintenance mode is on</span>
            )}

            {config.menuItems.map(item => (
              <AdminMenuItem item={item} key={item.title} />
            ))}

            {config.notifications && (
              <li className={styles.adminMenuNotifications}>
                <NotificationsLink
                  extraStyles={styles.adminMenuNotificationsLink}
                  {...config.notifications}
                />
              </li>
            )}
          </div>
        </ul>
      </nav>
    );
  }
}

AdminMenu.propTypes = {
  config: PropTypes.shape({
    logoUrl: PropTypes.string.isRequired,
    maintenance: PropTypes.bool,
    menuButtons: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired
      }).isRequired
    ),
    menuItems: PropTypes.arrayOf(
      PropTypes.shape({
        icon: adminMenuChildPropTypes.item.icon,
        items: adminMenuChildPropTypes.item.items,
        title: adminMenuChildPropTypes.item.title,

        /** If the `items` prop isn't passed, give it a URL. */
        url: adminMenuChildPropTypes.item.url
      }).isRequired
    ).isRequired,
    notifications: PropTypes.shape({
      count: PropTypes.number,
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    })
  }).isRequired
};
